import { GoJsContextMenuOptions, GojsContextMenuService } from '@y42/gojs';
import { CommandHandler, Diagram, Link, Node } from 'gojs';

export interface OrchestrationGoJsCommandHandleInjector {
  gojsContextMenuService: GojsContextMenuService;
}

export class OrchestrationGoJsCommandHandler extends CommandHandler {
  constructor(private readonly injector: OrchestrationGoJsCommandHandleInjector) {
    super();
  }

  showCustomContextMenu(options: GoJsContextMenuOptions, diagram: Diagram) {
    const gojsContextMenuService = this.injector.gojsContextMenuService;
    gojsContextMenuService.show(options, diagram);
  }

  hideCustomContextMenu() {
    const gojsContextMenuService = this.injector.gojsContextMenuService;
    gojsContextMenuService.hide();
  }

  deleteNode(node: Node): void {
    this.diagram.startTransaction('transaction:deleteNode');
    this.diagram.remove(node);
    this.diagram.commitTransaction('transaction:deleteNode');
  }

  deleteLink(link: Link): void {
    this.diagram.startTransaction('transaction:deleteLink');
    this.diagram.remove(link);
    this.diagram.commitTransaction('transaction:deleteLink');
  }
}
